import { render, staticRenderFns } from "./LearningUnitList.vue?vue&type=template&id=ebc29534&scoped=true&"
import script from "./LearningUnitList.vue?vue&type=script&lang=js&"
export * from "./LearningUnitList.vue?vue&type=script&lang=js&"
import style0 from "./LearningUnitList.vue?vue&type=style&index=0&id=ebc29534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc29534",
  null
  
)

export default component.exports